import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { apps } from '../data/apps';

const billedApps = apps.filter((app) => app.webBilling);

// 网页订阅（Paddle）的总销售条款：所有 App 共用，各 App 自己的使用条款另外适用
const Terms: React.FC = () => {
  return (
    <LegalLayout title="Terms of Sale" lastUpdated="October 24, 2026">
      <p>
        These terms apply to Premium subscriptions that you buy on the websites of our apps. They are provided by
        Spiegelei Studio (Inh. Bing Xia), Hedwig-Wachenheim-Karree 142, 51107 Cologne, Germany
        (“we”, “us”). Each app also has its own terms of use, which cover how you use the app:
      </p>
      <ul>
        {billedApps.map((app) => (
          <li key={app.id}>
            {app.title}: <a href={app.webBilling!.termsUrl}>Terms of Use</a>
          </li>
        ))}
      </ul>

      <h2>What we sell</h2>
      <p>
        Our products are software: mobile apps and browser extensions. Premium is an optional subscription that
        unlocks extra features inside the app, such as AI explanations or additional content, and is available
        online right after purchase. All our apps can be used for free without a subscription.
      </p>

      <h2>Merchant of Record</h2>
      <p>
        Our order process is conducted by our online reseller Paddle.com. Paddle.com is the Merchant of Record for
        all our orders. Paddle provides all customer service inquiries and handles returns. Paddle’s{' '}
        <a href="https://www.paddle.com/legal/checkout-buyer-terms" target="_blank" rel="noopener noreferrer">
          buyer terms
        </a>{' '}
        apply to the purchase in addition to these terms.
      </p>

      <h2>Prices and taxes</h2>
      <p>
        The price of each subscription is shown on the app’s pricing page and in the checkout before you pay.
        The checkout shows the price in your local currency, including or plus the sales tax or VAT that applies in
        your country.
      </p>

      <h2>Subscriptions and cancellation</h2>
      <p>
        Premium is available as a monthly or yearly subscription. It renews automatically at the end of each
        period until you cancel. You can cancel at any time through the link in the receipt email from Paddle, on
        the account page of the app’s website, or by writing to us. After you cancel, Premium stays active until
        the end of the period you have already paid for.
      </p>
      <p>
        Purchases made inside the iOS or Android apps are billed by Apple or Google under their own terms and are
        managed in your App Store or Google Play account.
      </p>

      <h2>Refunds</h2>
      <p>
        Every payment on our websites comes with a 14-day money-back guarantee. See our{' '}
        <a href="/refund">Refund Policy</a>.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about a purchase, write to{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a>, or look up your purchase at{' '}
        <a href="https://paddle.net" target="_blank" rel="noopener noreferrer">paddle.net</a>.
      </p>
    </LegalLayout>
  );
};

export default Terms;
